<form (ngSubmit)="base.onSubmit()" [formGroup]="base.form">
  <formly-form [fields]="base.fields" [form]="base.form" [model]="base.model" [options]="base.options"/>

  <ng-content></ng-content>

  <div class="submit-button">
      <button [disabled]="!base.form.valid" i18n nbButton status="primary" type="submit">Сохранить</button>

      <button (click)="base.modalClose()" *ngIf="base.isModal" i18n="@@Close" nbButton status="basic" type="button">Закрыть</button>

      <button (click)="base.back()" *ngIf="!base.isModal" i18n nbButton status="basic" type="button">Отмена</button>

      <button (click)="focusFirstError($event)" *ngIf="!base.form.valid && !base.loading && base.form.enabled" nbButton status="control" type="button" style="font-weight: normal">
        <nb-icon status="warning" icon="alert-triangle-outline"/> Не заполненные поля
      </button>

      <ng-content select="[moreButtons]"></ng-content>
  </div>
</form>
